import TextField from "@mui/material/TextField";
import {styled} from "@mui/material/styles";
import WorkAgreement, { WorkAgreementFieldCategory } from "work/entities/work-agreement/work-agreement";

const ProposalContainer = styled("div")(
  ({theme}) => ({
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
    },
    display: "grid",
    gap: theme.spacing(6),
    gridTemplateColumns: "auto auto",
    width: "100%",
  }));
const GeneralSection = styled("div")(
  () => ({
    display: "flex",
    flexDirection: "column",
  }));
const DateSection = styled("div")(
  ({theme}) => ({
    display: "flex",
    flexDirection: "column",
    "& .MuiFormControl-root": {
      marginTop: theme.spacing(1),
    },
  }));
const ClientTextField = styled(TextField)(
  ({theme}) => ({
    [theme.breakpoints.down("md")]: {
      minWidth: "unset",
      width: "100%",
    },
    margin: theme.spacing(
      1,
      0
    ),
    minWidth: theme.spacing(50),
  }));
const NameTextField = styled(TextField)(
  ({theme}) => ({
    [theme.breakpoints.down("md")]: {
      minWidth: "unset",
      width: "100%",
    },
    margin: theme.spacing(
      1,
      0
    ),
    minWidth: theme.spacing(50),
  }));
const DescriptionTextField = styled(TextField)(
  ({theme}) => ({
    [theme.breakpoints.down("md")]: {
      minWidth: "unset",
      width: "100%",
    },
    margin: theme.spacing(
      1,
      0
    ),
    minWidth: theme.spacing(50),
  }));
const DateContainer = styled("div")(
  ({theme}) => ({
    display: "flex",
    margin: theme.spacing(
      1,
      0
    ),
    width: "100%",
  }));

type DetailsTabProps = {
  activeTab: WorkAgreementFieldCategory;
  workAgreement: WorkAgreement;
};

export default function DetailsTab(props: Readonly<DetailsTabProps>) {
  const {
    activeTab,
    workAgreement
  } = props;

  if (activeTab !== WorkAgreementFieldCategory.Details) return null;

  return (
    <ProposalContainer>
      <GeneralSection>
        <ClientTextField
          disabled={true}
          label={
            workAgreement.client?.name.toString()
              ? "Client Representative"
              : "Select Client Representative"
          }
          error={false}
          value={workAgreement.client?.name.toString() ?? ""}
        />
        <NameTextField
          label="Proposal Name"
          disabled={true}
          value={workAgreement.name?.value ?? ""}
          error={false}
        />
        <DescriptionTextField
          label="Description"
          multiline={true}
          rows={3}
          disabled={true}
          value={workAgreement.description?.value ?? ""}
          error={false}
        />
      </GeneralSection>
      <DateSection>
        <DateContainer>
          <TextField
            disabled={true}
            value={workAgreement.startDate?.format('MM/DD/YY') ?? 'None'}
            label="Start Date"
          />
        </DateContainer>
        <DateContainer>
          <TextField
            disabled={true}
            value={workAgreement.endDate?.format('MM/DD/YY') ?? 'None'}
            label="End Date"
          />
        </DateContainer>
      </DateSection>
    </ProposalContainer>
  );
}
